// Angular
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { IVariableEntry } from "../../../../model/IVariableEntry";
import { IFieldSpecs } from "../interfaces/field-specs";

@Component({
    selector: 'simple-textarea-field-with-variables',
    template: `
        <simple-textarea-field
            [fieldConfig]="fieldConfig"></simple-textarea-field>

        <variables-help *ngIf="variablesConfig && variablesConfig.canUseVariables && variablesConfig.help"
            (onSelectVariable)="selectVariable()"
            (onSelectVariableError)="selectVariable($event)"
            [root]="variablesConfig && variablesConfig.help"></variables-help>
    `
})
export class SimpleTextareaFieldWithVariablesComponent {
    @Input()
    public variablesConfig: {canUseVariables: boolean, help: IVariableEntry} = null;

    @Input()
    public fieldConfig: IFieldSpecs;

    @Output()
    public onSelectVariable: EventEmitter<null> = new EventEmitter();

    @Output()
    public onSelectVariableError: EventEmitter<Error> = new EventEmitter();

    public selectVariable (error?: Error): void {
        if (error) {
            this.onSelectVariable.emit();
        } else {
            this.onSelectVariableError.emit(error);
        }
    }
}